import React, { useEffect, useMemo, useState } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EditarZona({ initial, onClose = () => {}, onSaved = () => {} }) {
  const id = useMemo(() => initial?.id ?? null, [initial]);
  const [nombre, setNombre] = useState(initial?.nombre || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const isValid = nombre.trim() !== "";
  const changed = useMemo(() => nombre !== (initial?.nombre || ""), [nombre, initial]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const handleSave = async () => {
    if (!id || !changed || !isValid || saving) return;
    setSaving(true);
    setError("");
    try {
      const payload = { nombre: nombre.trim() };
      const updated = await appFetchJson(apiRoutes.zonas.update(id), {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      onSaved(updated);
      onClose();
    } catch (e) {
      console.error("Error actualizando zona:", e);
      setError(e?.message || "Error al actualizar la zona.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Editar Zona</h2>
          <button className="modal-close-x" onClick={onClose}><FaTimes /></button>
        </div>
        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">Modifique el nombre de la zona</p>
          {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}
          <div className="form-grid">
            <div className="form-row">
              <label className="form-label">Nombre *</label>
              <input
                type="text"
                className="input"
                value={nombre}
                onChange={e => setNombre(e.target.value)}
                placeholder="Nombre de la zona"
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar label="Guardar" isValid={isValid && changed} saving={saving} onClick={handleSave} />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}